import React, { useContext } from 'react';
import './MessageThread.css';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import { differenceInSeconds } from 'date-fns';
import Message from '../Message/Message';
import logComponent from '../../common/logComponent';

export default function MessageThread({ messages, thread }) {
  const environmentContext = useContext(EnvironmentContext);
  const { activeUser: user } = environmentContext;

  if (logComponent('MessageThread')) { console.debug('MessageThread rendered'); }

  const showTimeOnMessage = (message, index) => {
    if (logComponent('MessageThread')) { console.debug('MessageThread showTimeOnMessage'); }

    if (index + 1 < messages.length && 
        message.CreatedByUserId === messages[index + 1].CreatedByUserId) {
      let messageDifferenceInSeconds = differenceInSeconds(messages[index + 1].SentOn, message.SentOn)

      if (messageDifferenceInSeconds < 60) return false;
    }       

    return true;
  }


  return (
    <ul className="Message-Thread">
      {
        messages.map((message, index) => {
          const showTime = showTimeOnMessage(message, index);
          return (
            <Message
              key={message.userMessageId}
              own={message.createdByUser.groupTypeString === user.groupTypeString}
              message={message}
              thread={thread}
              showTimeAndSender={showTime} />);
        })
      }
    </ul>
  );
}
